import React, {
  Component, useCallback, useEffect, useState,
} from 'react';
import {
  ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Row, Button,
} from 'reactstrap';
import { withApollo } from 'react-apollo';
import { GET_DISCOUNT_CODE, GET_FREE_HEART_CODE } from '../../mutation/mutation';

const STORES = [
  { id: 'US', name: 'USA' },
  { id: 'EU', name: 'France' },
  { id: 'AU', name: 'Australia' },
  { id: 'GB', name: 'UK' },
  { id: 'EU2', name: 'Europe' },
  { id: 'CA', name: 'Canada' },
];

const getStoreNameById = (id) => STORES.find((store) => store.id === id).name;

const StoresDropdown = ({ selectStore }) => {
  const [dropdownOpen, setOpen] = useState(false);
  const [selectedStore, setSelectedStore] = useState(STORES[0]);

  const toggle = useCallback(() => setOpen(!dropdownOpen), [setOpen, dropdownOpen]);

  useEffect(() => {
    selectStore(selectedStore.id);
  }, [selectedStore]);

  return (
    <ButtonDropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret color="primary" style={{ minWidth: '150px', top: '-6px' }}>
        {selectedStore.name}
      </DropdownToggle>
      <DropdownMenu>
        {STORES.map((store) => (
          <DropdownItem key={store.id} onClick={() => setSelectedStore(store)}>
            <span style={selectedStore.id === store.id ? { fontWeight: 800 } : {}}>
              {store.name}
            </span>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </ButtonDropdown>
  );
};

class GiveDiscountCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      discount: null,
      discountCode: null,
      store: STORES[0].name,
    };
    this.requestDiscountCode = this.requestDiscountCode.bind(this);
    this.requestFreeHeartCode = this.requestFreeHeartCode.bind(this);
    this.selectStore = this.selectStore.bind(this);
  }

  selectStore(store) {
    this.setState({ store, discount: null, discountCode: null });
  }

  requestDiscountCode(discount) {
    const { client } = this.props;
    const { store } = this.state;
    client.mutate({
      mutation: GET_DISCOUNT_CODE,
      variables: {
        store,
        discount,
      },
    })
      .then(({ data }) => {
        if (data && data.savCreateDiscountCode) {
          this.setState({
            discount,
            discountCode: data.savCreateDiscountCode,
            store,
          });
        } else {
          this.setState({ discountCode: 'Error :(' });
        }
      })
      .catch(() => {
        this.setState({ discountCode: 'Error :(' });
      });
  }

  requestFreeHeartCode() {
    const { client } = this.props;
    const { store } = this.state;
    client.mutate({
      mutation: GET_FREE_HEART_CODE,
      variables: {
        store,
      },
    })
      .then(({ data }) => {
        if (data && data.savCreateFreeHeartCode) {
          this.setState({
            discountCode: data.savCreateFreeHeartCode,
            store,
          });
        } else {
          this.setState({ discountCode: 'Error :(' });
        }
      })
      .catch(() => {
        this.setState({ discountCode: 'Error :(' });
      });
  }

  render() {
    const {
      discount,
      discountCode,
      store,
    } = this.state;
    return (
      <div>
        {
          discountCode && (
            <Row style={{ justifyContent: 'center', marginBottom: 20 }}>
              <h1>{discountCode}</h1>
              <p>{`Store ${getStoreNameById(store)} - ${discount}%`}</p>
              <Button
                color="success"
                style={{ marginLeft: 20, width: 100 }}
                onClick={() => navigator.clipboard.writeText(discountCode)}
              >
                Copy
              </Button>
            </Row>
          )
        }
        <Row style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <StoresDropdown selectStore={this.selectStore} />
          <Button className="discountButton" onClick={() => this.requestFreeHeartCode()}>Free Heart</Button>
          <Button className="discountButton" onClick={() => this.requestDiscountCode(5)}>5%</Button>
          <Button className="discountButton" onClick={() => this.requestDiscountCode(10)}>10%</Button>
          <Button className="discountButton" onClick={() => this.requestDiscountCode(15)}>15%</Button>
          <Button className="discountButton" onClick={() => this.requestDiscountCode(20)}>20%</Button>
          <Button className="discountButton" onClick={() => this.requestDiscountCode(30)}>30%</Button>
          <Button className="discountButton" onClick={() => this.requestDiscountCode(40)}>40%</Button>
          <Button className="discountButton" onClick={() => this.requestDiscountCode(50)}>50%</Button>
        </Row>
      </div>
    );
  }
}

export default withApollo(GiveDiscountCode);



// WEBPACK FOOTER //
// ./src/components/user-info/GiveDiscountCode.js